// extracted by mini-css-extract-plugin
export default {"bg":"Referral_bg__gK3ZV","referralFooter":"Referral_referralFooter__IwUAU"};